
export default function MarketsSection() {
  const markets = [
    {
      title: 'Elevadores Corporativos',
      description: 'Impacto direto em executivos e profissionais durante o trajeto diário',
      image: 'https://seemediabrasil.com.br/images/Gemini_Generated_Image_q5fpaq5fpaq5fpaq.webp',
      icon: 'ri-building-line'
    },
    {
      title: 'Elevadores Residenciais',
      description: 'Conexão com famílias e moradores em momentos de atenção exclusiva',
      image: 'https://seemediabrasil.com.br/images/Gemini_Generated_Image_4004f24004f24004.webp',
      icon: 'ri-home-line'
    },
    {
      title: 'Mercados Autônomos',
      description: 'Experiência de compra inteligente com publicidade contextual',
      image: 'https://seemediabrasil.com.br/images/Gemini_Generated_Image_c6uc8hc6uc8hc6uc.webp',
      icon: 'ri-store-line'
    },
    {
      title: 'Bares, Lojas e Restaurantes',
      description: 'Engajamento em pontos de alta circulação e tempo de permanência',
      image: 'https://seemediabrasil.com.br/images/Gemini_Generated_Image_nnhz61nnhz61nnhz.webp',
      icon: 'ri-restaurant-line'
    }
  ];

  return (
    <section id="mercados" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Onde <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Atuamos</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Presença estratégica nos principais pontos de circulação urbana
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {markets.map((market, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={market.image}
                  alt={market.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                    <i className={`${market.icon} text-white text-xl`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{market.title}</h3>
                <p className="text-gray-600 leading-relaxed">{market.description}</p>
                
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-500">Cobertura Ativa</span>
                    <span className="text-green-600 font-semibold">
                      <i className="ri-check-line mr-1"></i>
                      Disponível
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">45 Telas Instaladas</h3>
          <p className="text-xl opacity-90 mb-6">Centenas de campanhas ativas gerando resultados reais</p>
          <div className="grid md:grid-cols-3 gap-8 mt-8">
            <div>
              <div className="text-3xl font-bold">45+</div>
              <div className="text-sm opacity-80">Telas Ativas</div>
            </div>
            <div>
              <div className="text-3xl font-bold">500+</div>
              <div className="text-sm opacity-80">Campanhas Executadas</div>
            </div>
            <div>
              <div className="text-3xl font-bold">1M+</div>
              <div className="text-sm opacity-80">Impressões Mensais</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
